// local data는 빌드 시 파일 생성하지 않도록 fetch로 호출
export const getLocalData = async (alias: string, params?: { [key: string]: string }) => {
  return fetch(`/ts/common/data/${alias}.json?${new URLSearchParams(params)?.toString()}`).then((res) => res?.json());
};
